'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.setDataSupport = setDataSupport;
exports.reset = reset;
exports.publishLocalFeed = publishLocalFeed;
exports.sendData = sendData;
exports.attachLocalFeed = attachLocalFeed;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
var _utilsJanus = require('../utils/janus');
var _utilsJanus2 = _interopRequireDefault(_utilsJanus);
var ATTACH_MCU_ERROR = 'ATTACH_MCU_ERROR';
exports.ATTACH_MCU_ERROR = ATTACH_MCU_ERROR;
var ROOM_EXISTS_ERROR = 'ROOM_EXISTS_ERROR';
exports.ROOM_EXISTS_ERROR = ROOM_EXISTS_ERROR;
var CREATE_ROOM_ERROR = 'CREATE_ROOM_ERROR';
exports.CREATE_ROOM_ERROR = CREATE_ROOM_ERROR;
var AUDIO_DISABLED = 'AUDIO_DISABLED';
exports.AUDIO_DISABLED = AUDIO_DISABLED;
var ROOM_LOCAL_FEED = 'ROOM_LOCAL_FEED';
exports.ROOM_LOCAL_FEED = ROOM_LOCAL_FEED;
var ROOM_LOCAL_FEED_ERROR = 'ROOM_LOCAL_FEED_ERROR';
exports.ROOM_LOCAL_FEED_ERROR = ROOM_LOCAL_FEED_ERROR;
var ROOM_LOCAL_STREAM = 'ROOM_LOCAL_STREAM';
exports.ROOM_LOCAL_STREAM = ROOM_LOCAL_STREAM;
var ROOM_REMOTE_FEED = 'ROOM_REMOTE_FEED';
exports.ROOM_REMOTE_FEED = ROOM_REMOTE_FEED;
var ROOM_REMOTE_FEED_ERROR = 'ROOM_REMOTE_FEED_ERROR';
exports.ROOM_REMOTE_FEED_ERROR = ROOM_REMOTE_FEED_ERROR;
var ROOM_REMOTE_STREAM = 'ROOM_REMOTE_STREAM';
exports.ROOM_REMOTE_STREAM = ROOM_REMOTE_STREAM;
var ROOM_REMOVE_FEED = 'ROOM_REMOVE_FEED';
exports.ROOM_REMOVE_FEED = ROOM_REMOVE_FEED;
var ROOM_DESTROYED = 'ROOM_DESTROYED';
exports.ROOM_DESTROYED = ROOM_DESTROYED;
var ROOM_ICE_ERROR = 'ROOM_ICE_ERROR';
exports.ROOM_ICE_ERROR = ROOM_ICE_ERROR;
var ROOM_LOCAL_DATA = 'ROOM_LOCAL_DATA';
exports.ROOM_LOCAL_DATA = ROOM_LOCAL_DATA;
var ROOM_LOCAL_DATA_ERROR = 'ROOM_LOCAL_DATA_ERROR';
exports.ROOM_LOCAL_DATA_ERROR = ROOM_LOCAL_DATA_ERROR;
var ROOM_REMOTE_DATA = 'ROOM_REMOTE_DATA';
exports.ROOM_REMOTE_DATA = ROOM_REMOTE_DATA;
var ROOM_DATA_OPEN = 'ROOM_DATA_OPEN';
exports.ROOM_DATA_OPEN = ROOM_DATA_OPEN;
var feeds = [];
var dataSupport = false;
var mypvtid = null;
var opaqueId = 'videoroom-' + _utilsJanus2['default'].randomString(12);
function setDataSupport(_dataSupport) {
  dataSupport = !!_dataSupport;
}
function reset() {
  feeds = [];
}
function isRoomExists(dispatch, getState, videoRoomLocal) {
  var room = getState().janusConfig.room;
  return new Promise(function (resolve, reject) {
    videoRoomLocal.send({
      message: {
        request: 'exists',
        room: room.room
      },
      success: function success(result) {
        // Backward compatibility
        if (result.exists && result.exists !== 'false') {
          resolve();
        } else {
          reject();
        }
      },
      error: function error(_error) {
        dispatch({
          type: ROOM_EXISTS_ERROR,
          message: _error
        });
      }
    });
  });
}
function createRoom(dispatch, getState, videoRoomLocal) {
  var _getState$janusConfig = getState().janusConfig;
  var room = _getState$janusConfig.room;
  var publishers = _getState$janusConfig.publishers;
  console.log('MODULE -> create room-> FEED', getState().janusConfig);
  console.log('MODULE -> create room -> VIDEOROOMLOCAL', videoRoomLocal);
  return new Promise(function (resolve, reject) {
    videoRoomLocal.send({
      message: Object.assign(room, {
        publishers: publishers
      }),
      success: function success() {
        resolve();
      },
      error: function error(_error2) {
        dispatch({
          type: CREATE_ROOM_ERROR,
          message: _error2
        });
      }
    });
  });
}

// Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any

function publishLocalFeed(audio, video) {
  return function (dispatch, getState) {
    var feeds = getState().videoRoom.feeds;
    var videoRoomLocal = feeds.filter(function (feed) {
      return !feed.remote;
    })[0].plugin;
    console.log('MODULE -> publishLocalFeed -> FEED', feeds.filter(function (feed) {
      return !feed.remote;
    })[0]);
    console.log('MODULE -> publishLocalFeed -> VIDEOROOMLOCAL', videoRoomLocal);

    // Publish our stream
    return new Promise(function (resolve, reject) {
      videoRoomLocal.createOffer({
        media: {
          audioRecv: false,
          videoRecv: false,
          audioSend: !!audio,
          videoSend: !!video,
          audio: audio,
          video: video,
          data: dataSupport
        },
        // Publishers are sendonly
        forced: true,
        success: function success(jsep) {
          var publish = {
            request: 'configure',
            audio: !!audio,
            video: !!video
          };
          videoRoomLocal.send({
            message: publish,
            jsep: jsep,
            success: function success() {
              resolve();
            },
            error: function error(_error3) {
              reject(_error3);
            }
          });
          if (!audio) {
            dispatch({
              type: AUDIO_DISABLED
            });
          }
        },
        error: function error(message) {
          // Webrtc error
          if (audio) {
            dispatch(publishLocalFeed(false, video));
          } else {
            reject(message);
            dispatch({
              type: ROOM_LOCAL_FEED_ERROR,
              message: message
            });
          }
        }
      });
    });
  };
}
function sendData(data) {
  data = data || null;
  return function (dispatch, getState) {
    var feeds = getState().videoRoom.feeds;
    var videoRoomLocal = feeds.filter(function (feed) {
      return !feed.remote;
    })[0].plugin;
    return new Promise(function (resolve, reject) {
      videoRoomLocal.data({
        text: JSON.stringify(data),
        success: function success() {
          resolve();
          dispatch({
            type: ROOM_LOCAL_DATA,
            data: data
          });
        },
        error: function error(message) {
          reject(message);
          dispatch({
            type: ROOM_LOCAL_DATA_ERROR,
            message: message
          });
        }
      });
    });
  };
}
function join(videoRoomLocal) {
  return function (dispatch, getState) {
    console.log('MODULE -> JOIN in ', getState(), getState.janusConfig);
    var _getState$janusConfig2 = getState().janusConfig;
    var room = _getState$janusConfig2.room;
    var user = _getState$janusConfig2.user;
    var joinToRoom = function joinToRoom() {
      var data = {
        request: 'join',
        room: room.room,
        ptype: 'publisher',
        display: JSON.stringify(user)
      };
      videoRoomLocal.send({
        message: data
      });
    };
    isRoomExists(dispatch, getState, videoRoomLocal).then(joinToRoom)['catch'](function () {
      // Create room automatically
      if (room.request && room.request === 'create') {
        createRoom(dispatch, getState, videoRoomLocal).then(joinToRoom);
      }
    });
  };
}

// A new feed has been published, create a new plugin handle and attach to it as a listener
function attachRemoteFeed(id, user) {
  return function (dispatch, getState) {
    var _getState$janusConfig3 = getState().janusConfig;
    var room = _getState$janusConfig3.room;
    var publishers = _getState$janusConfig3.publishers;
    var janus = getState().mcu.janus;
    var feed = {
      id: id,
      user: user,
      remote: true
    };
    janus.attach({
      plugin: "janus.plugin.videoroom",
      opaqueId: opaqueId,
      success: function success(pluginHandle) {
        feed.plugin = pluginHandle;
        // We wait for the plugin to send us an offer
        var listen = {
          request: 'join',
          room: room.room,
          ptype: 'listener',
          feed: feed.id,
          private_id: mypvtid
        };
        feed.plugin.send({
          message: listen
        });
      },
      error: function error(_error4) {
        dispatch({
          type: ATTACH_MCU_ERROR,
          message: _error4
        });
      },
      onmessage: function onmessage(msg, jsep) {
        var event = msg.videoroom;
        if (event) {
          if (event === 'attached') {
            // Subscriber created and attached
            // Don't rewrite with itself
            var existedFeed = feeds.filter(function (_feed) {
              return feed.user.id === _feed.user.id;
            })[0];
            if (!existedFeed) {
              feeds.push(feed);
              dispatch({
                type: ROOM_REMOTE_FEED,
                feed: feed,
                feeds: feeds.slice(0)
              });
            }
            // Successfully attached
          } else {
            // What has just happened?
          }
        }
        if (jsep) {
          // Answer and attach
          feed.plugin.createAnswer({
            jsep: jsep,
            // We want recvonly audio/video
            media: {
              audioSend: false,
              videoSend: false,
              data: dataSupport
            },
            success: function success(jsep) {
              var body = {
                request: 'start',
                room: room.room
              };
              feed.plugin.send({
                message: body,
                jsep: jsep
              });
            },
            error: function error(_error5) {
              // Webrtc error
              dispatch({
                type: ROOM_REMOTE_FEED_ERROR,
                message: _error5
              });
            }
          });
        }
      },
      webrtcState: function webrtcState(on) {
        _utilsJanus2['default'].log("Janus says this WebRTC PeerConnection (feed #" + feed.user.id + ") is " + (on ? "up" : "down") + " now");
      },
      ondata: function ondata(data) {
        dispatch({
          type: ROOM_REMOTE_DATA,
          data: JSON.parse(data)
        });
      },
      onlocalstream: function onlocalstream(stream) {
        // The subscriber stream is recvonly, we don't expect anything here
      },
      onremotestream: function onremotestream(stream) {
        // Use the existed feed
        feeds.forEach(function (_feed, i) {
          if (_feed.id === feed.id) {
            feed = Object.assign({}, feed, {
              stream: stream
            });
            feeds[i] = feed;
            dispatch({
              type: ROOM_REMOTE_STREAM,
              feed: feed,
              feeds: feeds.slice(0)
            });
          }
        });
      },
      oncleanup: function oncleanup() {}
    });
  };
}
function attachLocalFeed(janus) {
  return function (dispatch, getState) {
    var _getState$janusConfig4 = getState().janusConfig;
    var publishers = _getState$janusConfig4.publishers;
    var user = _getState$janusConfig4.user;
    var janus = getState().mcu.janus;
    var addRemoteFeed = function addRemoteFeed(publishers) {
      var list = publishers;
      for (var f in list) {
        dispatch(attachRemoteFeed(list[f].id, JSON.parse(list[f].display)));
      }
    };
    var feed = {
      user: user,
      remote: false
    };

    // Attach to video MCU test plugin
    janus.attach({
      plugin: "janus.plugin.videoroom",
      opaqueId: opaqueId,
      success: function success(pluginHandle) {
        feed.plugin = pluginHandle;
        dispatch(join(feed.plugin));
      },
      error: function error(_error6) {
        dispatch({
          type: ATTACH_MCU_ERROR,
          message: _error6
        });
      },
      consentDialog: function consentDialog(on) {
        _utilsJanus2['default'].debug("Consent dialog should be " + (on ? "on" : "off") + " now");
      },
      mediaState: function mediaState(medium, on) {
        _utilsJanus2['default'].log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);
      },
      webrtcState: function webrtcState(on) {
        _utilsJanus2['default'].log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
      },
      ondataopen: function ondataopen() {
        dispatch({
          type: ROOM_DATA_OPEN
        });
      },
      onmessage: function onmessage(msg, jsep) {
        var event = msg.videoroom;
        if (event) {
          if (event === 'joined') {
            var _publishers = msg.publishers;
            var id = msg.id;
            var private_id = msg.private_id;
            mypvtid = private_id;
            feed.id = id;
            feeds.push(feed);

            // Any new feed to attach to?
            if (_publishers) {
              addRemoteFeed(_publishers);
            }
            dispatch({
              type: ROOM_LOCAL_FEED,
              feed: feed,
              feeds: feeds.slice(0)
            });
          } else if (event === 'destroyed') {
            // The room has been destroyed
            dispatch({
              type: ROOM_DESTROYED
            });
          } else if (event === 'event') {
            // Any new feed to attach to?
            if (msg.publishers) {
              addRemoteFeed(msg.publishers);
            } else if (msg.leaving) {
              (function () {
                // One of the publishers has gone away?
                var leaving = msg.leaving,
                  removeFeed = feeds.filter(function (feed) {
                    return feed.id == leaving;
                  });

                //Remove feed
                if (removeFeed[0]) {
                  removeFeed = removeFeed[0];
                  removeFeed.plugin.detach();
                  feeds.splice(feeds.indexOf(removeFeed), 1);
                  dispatch({
                    type: ROOM_REMOVE_FEED,
                    feed: removeFeed,
                    feeds: feeds.slice(0)
                  });
                }
              })();
            } else if (msg.error) {
              //Some other error
            }
          }
        }
        if (jsep) {
          feed.plugin.handleRemoteJsep({
            jsep: jsep
          });
        }
      },
      onlocalstream: function onlocalstream(stream) {
        //Local video / audio
        var index = feeds.indexOf(feed);
        feed = Object.assign({}, feed, {
          stream: stream
        });
        feeds[index] = feed;
        dispatch({
          type: ROOM_LOCAL_STREAM,
          feed: feed,
          feeds: feeds.slice(0)
        });
        //Ice state checker
        var pc = feed.plugin.webrtcStuff.pc;
        if (pc) {
          pc.oniceconnectionstatechange = function () {
            if (pc.iceConnectionState === 'disconnected' || pc.iceConnectionState === 'failed') {
              dispatch({
                type: ROOM_ICE_ERROR,
                message: pc.iceConnectionState
              });
            }
          };
        }
      },
      onremotestream: function onremotestream(stream) {
        //The publisher stream is sendonly, we don't expect anything here
      },
      oncleanup: function oncleanup() {
        //Unpublish
      }
    });
  };
}